import React, { useState, useEffect } from 'react';
import { onUiEvent } from '../../events/error/errorEventBus';
import { StockLimitDialog } from '../cart/StockLimitDialog';


/**
 * 购物车错误弹窗监听器
 * 
 * 职责：
 * - 监听 'ui:dialog' 事件
 * - 根据事件类型渲染对应的错误弹窗
 * - 管理弹窗的打开/关闭状态
 * 
 * 架构层级：UI Layer (Layer 1)
 * 挂载位置：main-cart.tsx（与 ToastListener 并列）
 */

type DialogState = {
    type: 'stock-limit';
    maxQty: number;
    requestedQty?: number;
} | null;

export const ErrorDialogListener: React.FC = () => {
    const [dialogState, setDialogState] = useState<DialogState>(null);
    const [isOpen, setIsOpen] = useState(false);

    console.log('[ErrorDialogListener] Rendered with dialogState:', dialogState);

    useEffect(() => {
        console.log('🎧 [ErrorDialogListener] Setting up event listener');

        // 监听错误弹窗事件
        const unsubscribe = onUiEvent('ui:dialog', (detail) => {
            console.warn('🔔 [ErrorDialogListener] Event received!', detail);
            setDialogState(detail);
            console.log('[ErrorDialogListener] dialogState updated to:', detail);
            setIsOpen(true);
        });

        console.log('[ErrorDialogListener] Event listener registered');

        return () => {
            console.log('[ErrorDialogListener] Cleaning up event listener');
            unsubscribe();
        };
    }, []);

    const handleClose = () => {
        console.log('[ErrorDialogListener] Dialog close requested');
        setIsOpen(false);
    };

    const handleExited = () => {
        console.log('[ErrorDialogListener] Dialog exit animation completed');
        setDialogState(null);
    };

    // 根据事件类型渲染不同的弹窗
    if (dialogState?.type === 'stock-limit') {
        console.log('🖼️ [ErrorDialogListener] Rendering StockLimitDialog with:', {
            maxQuantity: dialogState.maxQty,
            requestedQuantity: dialogState.requestedQty
        });

        return (
            <StockLimitDialog
                open={isOpen}
                onClose={handleClose}
                onExited={handleExited}
                maxQuantity={dialogState.maxQty}
                requestedQuantity={dialogState.requestedQty}
            />
        );
    }

    console.log('[ErrorDialogListener] No dialog to render, returning null');
    return null;
};
